import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';

const $body = $('body');
const $wrapper = $('.wrapper');
const sLineBottomFixed = 'wrapper_line-bottom-fixed';

function setWrapperClass() {
    if ($body.find('.article-share_fixed').length || $body.find('.sale_fixed').length) {
        if (getW() < eksmoBP.mdMin) {
            $wrapper.addClass(sLineBottomFixed);
        } else {
            $wrapper.removeClass(sLineBottomFixed);
        }
    }
}

setWrapperClass();
$body.on('eksmoResizeWidth', setWrapperClass);